// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".b-form-datepicker > button,\n.b-form-datepicker > label {\n  color: rgba(255, 255, 255, 0.7) !important;\n}\n", ""]);
// Exports
module.exports = exports;
